import { motion } from "framer-motion";

export const SectionHead = ({ overline, title, accent, desc, center }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    {overline && (
      <motion.span
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-xs md:text-sm tracking-[0.25em] uppercase text-[#F2B705] font-bold"
      >
        {overline}
      </motion.span>
    )}
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.05 }}
      className="font-display font-black tracking-tighter text-4xl md:text-5xl mt-3 leading-[0.95]"
    >
      {title} {accent && <span className="text-gold-gradient">{accent}</span>}
    </motion.h2>
    {desc && (
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="text-white/55 mt-4 text-base md:text-lg font-light"
      >
        {desc}
      </motion.p>
    )}
  </div>
);
